/**
 * Auth Routes
 *
 * Titles/descriptions/breadcrumbs are auto-resolved by the i18n router
 * guard from each route's `name` — see `src/plugins/i18n/routeI18n.ts`.
 */
import LoginPage from '../pages/auth/LoginPage.vue'
import RegistrationPage from '../pages/auth/RegistrationPage.vue'
import ForgotPasswordPage from '../pages/auth/ForgotPasswordPage.vue'
import ResetPasswordPage from '../pages/auth/ResetPasswordPage.vue'

export default [
  {
    path: '/register',
    name: 'auth.register',
    component: RegistrationPage
  },
  {
    path: '/login',
    name: 'auth.login',
    component: LoginPage
  },
  {
    path: '/forgot-password',
    name: 'auth.forgotPassword',
    component: ForgotPasswordPage
  },
  {
    path: '/reset-password',
    name: 'auth.resetPassword',
    component: ResetPasswordPage
  }
]
